// extracted by mini-css-extract-plugin
export default {"square":"square_square__8gm-b"};